export const fullpageOptions = {
    index: {
        anchors: ['top', 'simple', 'trusted', 'about']
    },
    business: {
        anchors: ['top', 'ease-of-use', 'email', 'aliases', 'functionality', 'storage', 'mobile', 'apps', 'safety', 'protection', 'pricing', 'features', 'since1998', 'about']
    },
    personal: {
        anchors: ['top', 'ease-of-use', 'email', 'storage', 'access', 'apps', 'safety', 'protection', 'pricing', 'features', 'since1998', 'about']
    }
};

export const debounceTimeout = 250;
